export default "__VITE_ASSET__DF06Q6kE__"